import { ImageProp } from './image';
import { Place } from './place';
import { City } from './city';

export const CATEGORIES_STATUS = {
  OPEN: 'OPEN',
  CLOSE_VISIBLE: 'CLOSE_VISIBLE',
  CLOSE_HIDDEN: 'CLOSE_HIDDEN',
};

export interface Quota {
  category: { id: number; title: string };
  is_unlimited: boolean;
  remainder: number;
  status: keyof typeof CATEGORIES_STATUS;
}

export interface EventDate {
  close_sale_timer: number | null;
  event: {
    id: number;
    title: string;
  };
  quotas: Quota[];
  start_date: string;
  time: string[];
  place: {
    id: string;
    title: string;
  };
  city: City;
}

export interface DateEvent {
  start_date: string; // 2022-04-02 yyyy-LL-dd
  end_date: string; // 2022-04-02 yyyy-LL-dd
  time: string[];
}

export interface EventCategory {
  id: number;
  quantity: number;
  remainder: number;
  remote_id: string;
  position: number;
  title: string;
  price: string;
  discount: null;
  max_quantity: number;
  sold: number;
  is_unlimited: boolean;
  fee: string;
  estimation: null;
  total_quota: null;
  is_active: boolean;
  status: string;
  product_bx_id: string;
  smartbilet_id: null;
  buy_form_text: null;
  show_remainder: boolean;
  event: number;
}

export interface CategoryData {
  alias: string;
  count: number;
  description: string;
  header_position: number;
  id: number;
  is_index: boolean;
  parent: null | number;
  seo_description: string;
  seo_h1: string;
  seo_keywords: string;
  seo_title: string;
  show_in_header: boolean;
  slug: string;
  title: string;
}

export interface Category extends CategoryData {
  children: CategoryData[];
}

export const ACTION_TYPES: {
  certificate: 'certificate';
  purchase: 'purchase';
  reservation: 'reservation';
  FREE: 'FREE';
  partner_widget: 'partner_widget';
  astra_marine: 'astra_marine';
  tsnext_widget: 'tsnext_widget';
} = {
  certificate: 'certificate',
  purchase: 'purchase',
  reservation: 'reservation',
  FREE: 'FREE',
  partner_widget: 'partner_widget',
  astra_marine: 'astra_marine',
  tsnext_widget: 'tsnext_widget',
};

export type ActionType = keyof typeof ACTION_TYPES;

export interface Action {
  title: string;
  short_description: string;
  smartbilet_url: string;
  images: ImageProp[];
  photo_preview: string;
  video_url: string;
  video_cover: string;
  id: number;
  remote_id: string;
  description: string;
  block_1_title: string;
  block_1_description: string;
  block_1_description_html: string | null;
  block_2_title: string;
  block_2_description: string;
  block_2_description_html: string | null;
  event_categories: EventCategory[];
  dates_txt: string;
  reservation_count_text: null | string;
  place_title: string;
  best_reviews: boolean;
  with_open_date: boolean;
  subscription_confirmed: boolean;
  hit: boolean;
  not_season: boolean;
  first_time: boolean;
  prepayment: boolean;
  premiere: boolean;
  instead_price: number | null;
  filter_price: number | null;
  display_price: string | null;
  marketing_category: string | null;
  discount: number | null;
  max_count_per_user: number;
  type: ActionType;
  cerificate_service_fee: string;
  service_fee: number | null;
  pushkin_card_payment: boolean;
  slug: string;
  status: string;
  condition_title: string;
  condition: string;
  views: number;
  comments_avg_rating: number;
  comments_count: number;
  age_category: string;
  price: string;
  duration: string | null;
  free_reservation_cancel: boolean;
  payment_on_spot: boolean;
  widget_script: string;
  dates_txt_detailed: { [key: string]: string[] }[];
  places: Place[];
  date_unknown: boolean;
  certificate_last_name_required: boolean;
  reservation_by_name_only: boolean;
  reservation_type: string;
  latest_event: DateEvent | null;
  nearest_event: DateEvent | null;
  countdown_type: string;
  countdown_datetime: string;
  tsnext_id: string;
  tsnext_type: string;
  dates: {
    close_sale_timer: number;
    end_date: string;
    event: number;
    event_categories: number[];
    first_time: string;
    id: number;
    place: number;
    quotas: {
      category_id: string;
      category_remote_id: string;
      category_title: string;
      is_unlimited: boolean;
      quantity: number;
    }[];
    remote_id: string;
    sale_is_closed: boolean;
    start_date: string;
    time: string[];
  }[];
  buy_form_text: string;
  remainder: number;
  show_remainder: boolean;
  countdown_tickets: any;
  url: string;
  ym_open: string;
  has_further_dates: boolean;
  image: ImageProp;
  city: City;
  cancellation_policy:
    | null
    | 'free_cancel'
    | '10_days'
    | 'no_refund'
    | 'discounted_no_refund';
}

export const RESERVATION_TYPES = {
  full: 'full',
  shortened: 'shortened',
};

export const QUOTA_REMAINDER_TYPES = {
  unlimited: 'unlimited',
  noTickets: 'noTickets',
  remainderCount: 'remainderCount',
};

export const actionFormFieldsNames = {
  first_name: 'name',
  last_name: 'surname',
  phone_number: 'phone',
  email: 'mail',
  date: 'date',
  time: 'date_time',
  count: 'count',
};

export interface PaymentItem {
  amount: number;
  amount_in_cents: number;
  is_agent_item: boolean;
  name: string;
  name_in_receipt: string;
  price: number;
  price_in_cents: number;
  quantity: number;
}
